module.exports = __webpack_public_path__ + "img/AAC-CMMC.05d4b3b4.png";